import { SubscriptionPlanType, SubscriptionStatus } from '@utils/interfaces';

export const OFFER_CODES = {
  [SubscriptionPlanType.Annual]: 'pw-deepai-pro-ann-699-july-25',
  [SubscriptionPlanType.Monthly]: 'pw-deepai-pro-mon-699-july-25',
  [SubscriptionStatus.CBPT]: 'pw-deepai-pro-cbpt-699-july-25',
  [SubscriptionStatus.LEAD]: 'pro-leads-deep-research-bc-pw-749-2025',
};

export const UPGRADE = 'Upgrade';
export const SUBSCRIBE_NOW = 'Subscribe now';
export const GET_STARTED = 'Get started';
